// Note that these have corresponding CSS values
// that need to be updated if these change.
export const PX_PER_COL = 25;
export const PX_PER_ROW = 25;
export const CAM_COLS   = 800 / PX_PER_COL;
export const CAM_ROWS   = 600 / PX_PER_ROW;
